const TokenKey = 'Token'
export function getToken() {
  return window.LS.get(TokenKey)
}

export function setToken(token) {
  return  window.LS.set(TokenKey, token)
}

export function removeToken() {
  return window.LS.remove(TokenKey)
}

const HdTokenKey = 'HdToken'
export function getHdToken() {
  return window.LS.get(HdTokenKey)
}

export function setHdToken(token) {
  return window.LS.set(HdTokenKey, token)
}

export function removeHdToken() {
  return  window.LS.remove(HdTokenKey)
}